export function notificationDestination(notification) {
  if (notification?.link) return notification.link;
  if (notification?.campaign_id) return `/campaigns/${notification.campaign_id}`;
  if (notification?.recruit_id) return `/recruits/${notification.recruit_id}?tab=outreach`;
  if (notification?.metadata?.contact_id) return '/contacts';
  return null;
}
